import { useState } from "react";
import { useNavigate } from "react-router";

import useUpsertProductLine from "../../../../clients/brands/useUpsertProductLine";
import useCanEditBrand from "../../../../clients/users/useCanEditBrand";

export default function useProductLineSaver(productLine, data, isDirtyRef?) {
    const [record] = useUpsertProductLine(data);
    const [error, setError] = useState<string | null>(null);

    const navigate = useNavigate();

    const canEditBrand = useCanEditBrand(productLine?.brandID ?? data?.brandID);

    if (!canEditBrand) return { save: null, error: null };

    async function save(event?: { preventDefault?: () => void }): Promise<boolean> {
        event?.preventDefault?.();
        setError(null);
        try {
            const x = await record();
            if (x.data.upsertProductLine.errors?.length) {
                setError(x.data.upsertProductLine.errors[0]?.message ?? "Unknown error");
                return false;
            }
            if (isDirtyRef) isDirtyRef.current = false;
            if (!productLine) {
                navigate(`../${ x.data.upsertProductLine.id.replaceAll("-", "") }`);
            }
            return true;
        } catch (e) {
            const error = e as { graphQLErrors?: { message?: string }[], message?: string };
            const message = error?.graphQLErrors?.[0]?.message ?? error?.message ?? "Unknown error";
            if (message.includes("E11000") && message.includes("key")) {
                setError("Key must be unique — another product line in this brand already uses this key.");
            } else if (message.includes("E11000")) {
                setError("Duplicate value — another product line already uses one of these unique fields.");
            } else {
                setError(message);
            }
            return false;
        }
    }

    return { save, error };
}
